import { getAccessToken } from '@/helpers/auth-helper'

export default function isNotAuth({ next }) {
    if (getAccessToken()) {
        return next({ name: 'NotFound' })
    }

    return next()
}
